import { render, staticRenderFns } from "./AssetOwnershipTab.vue?vue&type=template&id=27ae4d58"
import script from "./AssetOwnershipTab.vue?vue&type=script&lang=js"
export * from "./AssetOwnershipTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports